import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  actions: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 20,
    position: 'absolute',
    left: '-25px',
  },
  table: {
    height: '100%',
    overflowY: 'auto',
  },
}));
